import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import CommonBubble from '@/pages/home/components/CommonBubble';
import './index.scss';

interface DefinitionBubbleProps {
  children: React.ReactNode;
  definition?: string;
  updateTime?: string;
  updateTimeLabel?: string;
  source?: string;
  dark?: boolean;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  arrowPointAtCenter?: boolean;
  style?: React.CSSProperties;
}

const DefinitionBubble: React.FC<DefinitionBubbleProps> = ({
  children,
  definition,
  updateTime,
  updateTimeLabel = 'Update time:',
  source,
  dark = true,
  placement = 'top',
  arrowPointAtCenter = true,
  style,
}) => {
  // Check if any info data is provided
  const hasInfoData = definition || updateTime || source;

  const sanitizedDefinition = useMemo(() => {
    if (!definition) {
      return '';
    }
    const newText = definition.replace(/(\\n|\n)/g, '<br/>');
    return DOMPurify.sanitize(newText);
  }, [definition]);

  // Build bubble content
  const bubbleContent = hasInfoData ? (
    <div className="dbs-metrics-bubble-content">
      {definition && (
        <div className="dbs-metrics-bubble-row">
          <span className="dbs-metrics-bubble-label">Definition:</span>
          <span
            className="dbs-metrics-bubble-value"
            dangerouslySetInnerHTML={{ __html: sanitizedDefinition }}
          />
        </div>
      )}
      {updateTime && (
        <div className="dbs-metrics-bubble-row">
          <span className="dbs-metrics-bubble-label">{updateTimeLabel}</span>
          <span className="dbs-metrics-bubble-value">{updateTime}</span>
        </div>
      )}
      {source && (
        <div className="dbs-metrics-bubble-row">
          <span className="dbs-metrics-bubble-label">Source:</span>
          <span className="dbs-metrics-bubble-value">{source}</span>
        </div>
      )}
    </div>
  ) : null;

  return (
    <CommonBubble
      content={bubbleContent}
      dark={dark}
      placement={placement}
      arrowPointAtCenter={arrowPointAtCenter}
      style={style}
    >
      {children}
    </CommonBubble>
  );
};

export default DefinitionBubble;
